var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHotel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 72,
    viewBox: "0 0 71 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.0078125,
    y: 0.519531,
    width: 71.01,
    height: 70.7156,
    rx: 35.3578,
    fill: "#4745B7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.0951 24.7949V46.9595H39.696V37.8348H31.2975V46.9595H25.8984V24.7949H31.2975V33.4776H39.696V24.7949H45.0951Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHotel);
export default __webpack_public_path__ + "static/media/hotel.9224a7d246501b7ffa30d375ebd4d36c.svg";
export { ForwardRef as ReactComponent };